export const Header = () => {
  return (
    <div className="blog-header">
      <div className="blog-header__chip">Blog</div>
      <div className="blog-header__title">The Most Popular And Trending Topics</div>
    </div>
  )
}
